// extracted by mini-css-extract-plugin
export default {"container":"vrbzhhNvCv7V3bkSZkdi"};